import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  initReview,
  updateReview,
  updateReviewRating
} from '../modules/review/index';
import { RfqReview } from '../modules/review/index';

const useReview = () => {
  const dispatch = useDispatch();

  const onInitReview = useCallback(() => dispatch(initReview()), [dispatch]);

  const onUpdateReview = useCallback(
    (payload: RfqReview) => dispatch(updateReview(payload)),
    [dispatch]
  );

  const onUpdateReviewRating = useCallback(
    (payload: number | undefined) => dispatch(updateReviewRating(payload)),
    [dispatch]
  );

  return {
    onInitReview,
    onUpdateReview,
    onUpdateReviewRating
  };
};

export default useReview;
